// replaced on built file
export const VERSION = '17.2.1';
